module.exports = __webpack_public_path__ + "img/change-phone-number.72f85d19.png";